module.exports = __webpack_public_path__ + "img/xiaoxi.ce773637.png";